import { LANG_DEFAULT, RTL_MARKERS_REGEX } from "../constants";
import { SupportedLanguage } from "../models";
import { localStorageHelpers } from "./browser-storge";

export const getLangLocalStorage = (): SupportedLanguage | undefined => {
  const lang =
    localStorageHelpers.getItem<string | undefined>("i18nextLng") || undefined;
  return validatedLanguage(lang);
};

export const setLangLocalStorage = (lang: SupportedLanguage): void => {
  if (!lang) {
    return;
  }

  localStorageHelpers.setItem("i18nextLng", lang);
};

export const isRtl = (lang: SupportedLanguage): boolean => {
  return lang === "he";
};

export const validatedLanguage = (
  lang: string | undefined,
): SupportedLanguage | undefined => {
  if (!lang) {
    return undefined;
  }

  // i18next may report regional codes (e.g. "he-IL"); keep languageOnly codes.
  const languageOnly = lang.split("-")[0];

  if (languageOnly === "en" || languageOnly === "he") {
    return languageOnly;
  }

  return undefined;
};

/**
 * Resolves UI language: last local choice → profile/init preference →
 * current session language → default. Always returns a supported code so the
 * switcher never loses its icon to an invalid/undefined value.
 */
export const resolveAppLanguage = ({
  storedLanguage,
  preferenceLanguage,
  currentLanguage,
}: {
  storedLanguage?: string;
  preferenceLanguage?: string;
  currentLanguage?: string;
}): SupportedLanguage =>
  validatedLanguage(storedLanguage) ||
  validatedLanguage(preferenceLanguage) ||
  validatedLanguage(currentLanguage) ||
  LANG_DEFAULT;

export const removeRtlMarkers = (str: string): string => {
  return str.replace(RTL_MARKERS_REGEX, "");
};
